import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AllService {
  url = environment.url + 'all/';
  url_uu= environment.url_uu+'all/';




  constructor(private http: HttpClient) {}

  //AUDIT SERVICE
  updatelogin(t)
  {
      return this.http.post(this.url_uu+'updatelogin',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  savestaff(t)
  {
      return this.http.post(this.url_uu+'saveStaff',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }
  getSupervisorTeam(t)
  {
      return this.http.post(this.url_uu+'supervisorTeam',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }
  getTeam()
  {
      return this.http.get(this.url_uu+'getTeam').pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  saveWork(t)
  {
      return this.http.post(this.url_uu+'saveWork',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  getTeam_supervisor(t)
  {
      return this.http.post(this.url_uu+'getTeam_supervisor',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  saveWork_TeamMember(t)
  {
      return this.http.post(this.url_uu+'saveWork_TeamMember',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  getWork_TeamMember(t)
  {
      return this.http.post(this.url_uu+'getWork_TeamMember',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  getTeamWorkdetails(t)
  {
      return this.http.post(this.url_uu+'getTeamWorkdetails',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }


  getTeam_teamname(t)
  {
      return this.http.post(this.url_uu+'getTeam_teamname',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }


  getWork_supervisor(t)
  {
      return this.http.post(this.url_uu+'getWork_supervisor',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  getWorkdetails(t)
  {
      return this.http.post(this.url_uu+'getWorkdetails',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  getWork_objectives(t)
  {
      return this.http.post(this.url_uu+'getWork_objectives',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }


  getWork()
  {
      return this.http.get(this.url_uu+'getWork').pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  getWork_all()
  {
      return this.http.get(this.url_uu+'getWork_all').pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }
  saveTest(t)
  {
      return this.http.post(this.url_uu+'saveTest',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }


  getTest()
  {
      return this.http.get(this.url_uu+'getTest').pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  saveSupervisor(t)
  {
      return this.http.post(this.url_uu+'saveSupervisor',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }


  ///////
  getDepartment()
  {
      return this.http.get(this.url_uu+'department').pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  getDepartment_institution(t)
  {
      return this.http.post(this.url_uu+'department_institution',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }


  newDeptAssign(t)
  {
      return this.http.post(this.url_uu+'newDeptAssign',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  activity_assign_objectives(t)
  {
    console.log(t);
      return this.http.post(this.url_uu+'activity_assign_objectives',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  objective_assign_tests(t)
  {
    console.log(t);
      return this.http.post(this.url_uu+'objective_assign_tests',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }


  getObjectives_Activity(t)
  {
      return this.http.post(this.url_uu+'getObjectives_Activity',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  newLocationAssign(t)
  {
      return this.http.post(this.url_uu+'newLocationAssign',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }



  assignStaff(t)
  {
      return this.http.post(this.url_uu+'assignStaff',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  createTeam(t)
  {
      return this.http.post(this.url_uu+'createTeam',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  getDepartmentStaff()
  {
      return this.http.get(this.url_uu+'department_staff').pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }


  ////////
  getDepartmentStaff_all()
  {
      return this.http.get(this.url_uu+'department_staff_all').pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }
  

  getDepartmentStaff_()
  {
      return this.http.get(this.url_uu+'department_staff_').pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  
  getDepartment_Supervisor(t)
  {
      return this.http.post(this.url_uu+'supervisor_staff',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  getSuperviseeUnderSup(t)
  {
      return this.http.post(this.url_uu+'supervisee_understaff',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  getTeamUnderSup(t)
  {
      return this.http.post(this.url_uu+'team_understaff',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  getDepartment_Supervisor_department(t)
  {
      return this.http.post(this.url_uu+'supervisor_staff_dept',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  getDepartment_Leader_department()
  {
      return this.http.get(this.url_uu+'teamleader_dept').pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }


  getStaff_Details(t)
  {
      return this.http.post(this.url_uu+'staff_details',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }
  
  get_location()
  {
      return this.http.get(this.url_uu+'location_details').pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }
  
  Update_Staff_Details(t)
  {
      return this.http.post(this.url_uu+'update_staff_details',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }


  saveLocation(t)
  {
      return this.http.post(this.url_uu+'saveLocation',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }


  getLocation()
  {
      return this.http.get(this.url_uu+'getLocation').pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }


  saveActivity(t)
  {
      return this.http.post(this.url_uu+'saveActivity',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  getActivity()
  {
      return this.http.get(this.url_uu+'getActivity').pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  saveObjective(t)
  {
      return this.http.post(this.url_uu+'saveObjective',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  getObjective()
  {
      return this.http.get(this.url_uu+'getObjective').pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }
  
  saveInstitution(t)
  {
      return this.http.post(this.url_uu+'saveInstitution',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  getInstitution()
  {
      return this.http.get(this.url_uu+'getInstitution').pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  saveDirectorate(t)
  {
      return this.http.post(this.url_uu+'saveDirectorate',t).pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }

  getDirectorate()
  {
      return this.http.get(this.url_uu+'getDirectorate').pipe(
          map((response) =>{
            return response
          }),
          catchError(this.handleError)
      )
  }




  //AUDIT SERVICE
  getOperationalDash() {
    return this.http.get(this.url_uu + 'dash_estimate_lbconly').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  getOperationalDash_(d) {
    return this.http.post(this.url_uu + 'getOperationalDash_',d).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  lbc_data_all_lbconly(d) {
    return this.http.post(this.url_uu + 'lbc_data_all_lbconly' ,d ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  getNewReport(d) {
    return this.http.post(this.url_uu + 'getNewReport' ,d ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }


  getRegion_data(d) {
    return this.http.post(this.url_uu + 'getRegion_data' ,d ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }
  lbc_data_all_lbconly_approved(d) {
    return this.http.post(this.url_uu + 'lbc_data_all_lbconly_approved' ,d ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  getdistrict_lbconly_approved(d) {
    return this.http.post(this.url_uu + 'getdistrict_lbconly_approved' ,d ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  getdistrict_lbconly(d) {
    return this.http.post(this.url_uu + 'getdistrict_lbconly' ,d ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  getpc_lbconly(d) {
    return this.http.post(this.url_uu + 'getpc_lbconly' ,d ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }
  approvepc_lbconly(d) {
    return this.http.post(this.url_uu + 'approvepc_lbconly' ,d ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }
  updatepc_lbconly(d) {
    return this.http.post(this.url_uu + 'updatepc_lbconly' ,d ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }



  get_regions() {
    return this.http.get(this.url_uu + 'pcdata_regions'  ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  pcdata_lbc_district(t) {
    return this.http.post(this.url_uu + 'pcdata_lbc_district' ,t ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }


  pcdata_lbc_district_lbc(t) {
    return this.http.post(this.url_uu + 'pcdata_lbc_district_lbc' ,t ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }


  
  pcdata_lbc_district_lbc_all(t) {
    return this.http.post(this.url_uu + 'pcdata_lbc_district_lbc_allinregion' ,t ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }


  getDistrict(region) {

    let t={
      region:region
    }
    return this.http.post(this.url_uu +'getDistrict' , t ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }


  getlbc_district(t) {

  
    return this.http.post(this.url_uu +'getlbc_',t ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }


  getregion_district(t) {

  
    return this.http.post(this.url_uu +'getregion_district',t ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  updateDatabase(t)
  {
  return this.http.post(this.url_uu + 'upload_data_pcdata' , t ).pipe(

    map((response) => {
      return response;
    }),
    catchError(this.handleError)
  );
  }




  lbc_data_all() {

    return this.http.get(this.url_uu + 'lbc_data_all' ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  lbc_data_district() {

    return this.http.get(this.url_uu + 'lbc_data_district' ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }


  lbc_data_lbc_and_district() {

    return this.http.get(this.url_uu + 'lbc_data_lbc_and_district' ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }


  pcdata_district() {

    return this.http.get(this.url_uu + 'pcdata_district' ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
   }


  pcdata_makechange(t) {

    return this.http.post(this.url_uu + 'pcdata_makechange',t ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  pcdata_search(t) {

    return this.http.post(this.url_uu + 'pcdata_search',t ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  pcdata_search_all(t) {

    return this.http.post(this.url_uu + 'pcdata_search_all',t ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  pcdata_district_and_lbc(t) {

    return this.http.post(this.url_uu + 'pcdata_district_and_lbc',t ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }




  getRegion() {
    return this.http.get('https://pprsdapi.herokuapp.com/api/getRegion' ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }


 

 savePcData(t) {

   
    return this.http.post('https://pprsdapi.herokuapp.com/api/savePcData' , t ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }


  getPcData() {

   
    return this.http.get('https://pprsdapi.herokuapp.com/api/getPcData' ).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }




  /** Get Districts from Regional Code  */
  getDistricts(region_code) {
    return this.http.get(this.url + 'district/' + region_code).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }



  // getRegions(region_code) {
  //   return this.http.get(this.url + 'qcc_district/' + region_code).pipe(
  //     map((response) => {
  //       return response;
  //     }),
  //     catchError(this.handleError)
  //   );
  // }


  getQCCDistricts(region_code) {
    return this.http.get(this.url + 'qcc_district/' + region_code).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Card Search */

  cardSearch(data) {
    return this.http.post(this.url + 'card_search', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** */
  getOperationalDisName(data) {
    return this.http.post(this.url + 'ops_with_disname', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }
  /**  */

  /** Get Regions */
  getRegions() {
    return this.http.get(this.url + 'regions').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  async getArray(data, array) {
    const r: any = [];
    array.forEach((element) => {
      r.push(element[data]);
    });
    return r;
  }

  /** Get Others */

  getOthers() {
    return this.http.get(this.url + 'others').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Save Region */

  saveRegion(data) {
    return this.http.post(this.url + 'regions', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Edit Operational Area */
  editOperationalArea(data) {
    return this.http.put(this.url + 'operational_area', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get Operational Area */
  getOperational(district: string) {
    return this.http.get(this.url + 'operational_area/' + district).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get My Operational Area */
  getMyOperational() {
    return this.http.get(this.url + 'operational_area').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Save District */
  saveDistrict(data) {
    return this.http.post(this.url + 'district', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Edit District */
  editDistrict(data) {
    return this.http.put(this.url + 'district', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Supervisor District */
  getmySupDistrict() {
    return this.http.get(this.url + 'district_sup').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get Report */
  getManualReport() {
    return this.http.get(this.url + 'manual_report').pipe(
      map((response) => {
        return response;
      })
    );
  }

  /** Get y District */
  getmyDistrict() {
    return this.http.get(this.url + 'district').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Save Operational Area */

  saveOperation(data) {
    return this.http.post(this.url + 'operational_area', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Surveyors */
  saveSurveyor(data) {
    return this.http.post(this.url + 'surveyor', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  editSurveyor(data) {
    return this.http.put(this.url + 'surveyor', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /* Search Cea */
  getCEA(op_code) {
    return this.http.get(this.url + 'search_cea/' + op_code).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  getCEAByReference(data) {
    return this.http.post(this.url + 'search_cea/1', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  ceaCount() {
    return this.http.get(this.url + 'cea_count').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  getSurveyor() {
    return this.http.get(this.url + 'surveyor').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Data 1 */

  getData1(data) {
    return this.http.post(this.url + 'query_1', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Data 2 */
  getData2(data) {
    return this.http.post(this.url + 'query_2', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** User Total */
  getUserTotal() {
    return this.http.get(this.url + 'users').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  saveUser(data) {
    return this.http.post(this.url + 'users', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  getUsersToday() {
    return this.http.get(this.url + 'userstoday').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Search User */
  searchUser(data) {
    return this.http.post(this.url + 'search_user', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Selected Supervisor Details */
  selectedSupervisor(data) {
    return this.http.get(this.url + 'selected_supervisor/' + data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Load Enumerators */
  loadEnumerators(operational_code) {
    return this.http.post(this.url + 'enumerators', operational_code).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Move Enumerators */
  moveEnumerator(data) {
    return this.http.post(this.url + 'move_enumerators', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }



  moveUsers(data) {
    return this.http.post(this.url + 'move_users', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Movement List */

  movementList() {
    return this.http.get(this.url + 'movement_list').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Assignment Batch List */

  assignmentList() {
    return this.http.get(this.url + 'assignment_list').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Movement Details */

  movemenDetails(date) {
    return this.http.get(this.url + 'movement_details/' + date).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Enumerator Movement History */

  enumeratorMovementHistory(enumerator) {
    return this.http.get(this.url + 'movement_history/' + enumerator).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Update User */
  updateUser(data) {
    return this.http.put(this.url + 'users', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Search Enumerators */
  searchEnumReport() {
    return this.http.get(this.url + 'sup_enumerators').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get Enumerators */
  getEnumerators(supervisor) {
    return this.http.get(this.url + 'enumerators/' + supervisor).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get District Enumerators */
  getDistrictEnumerator() {
    return this.http.get(this.url + 'enumerator_district').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get District Supervisors */
  getDistrictSupervisor() {
    return this.http.get(this.url + 'enumerator_supervisor').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  getDistrictOperational() {
    return this.http.get(this.url + 'district_operational').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Enumerator Work With dates  */
  getEnumeratorWorkDates(data) {
    return this.http.post(this.url + 'enumerator_work', data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  /** Get Enumerator work summary */
  getEnumeratorWorkSummary(data) {
    return this.http.get(this.url + 'enumerator_work/' + data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  /** Get Supervisor work summary */
  getSupervisorWorkSummary(data) {
    return this.http.get(this.url + 'supervisor_work/' + data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  /** Enumerator Supervisor With dates  */
  getSupervisorWorkDates(data) {
    return this.http.post(this.url + 'supervisor_work', data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  /** Get Enumerator */
  fixEnumerationIssue(data) {
    return this.http.get(this.url + 'correct_enum/' + data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  /** Get Enumerators in an Operational Area */
  getEnumeratorOps(supervisor, operational_code) {
    return this.http
      .get(this.url + 'enumerators/' + supervisor + '/' + operational_code)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(this.handleError)
      );
  }

  /** Get Farmer Query */
  getFarmerQuery(data) {
    return this.http.post(this.url + 'farmer_query', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Assign Supervisor */

  assignSupervisor(data) {
    return this.http.post(this.url + 'supervisor_assign', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get Info */
  userTest(data) {
    return this.http.get(this.url + 'nana').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Search Farmer Details */
  searchFarmerFull(data) {
    return this.http.post(this.url + 'farmer_search', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Communities */
  communities(data) {
    return this.http.get(this.url + 'communities/' + data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get Relations */
  relation() {
    return this.http.get(this.url + 'relation').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Search Farmer By Reference */

  searchFarmerByReference(data) {
    return this.http.post(this.url + 'farmer_by_reference', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get Dependants */
  getDependant(data) {
    return this.http.get(this.url + 'dependent/' + data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /**  */
  myfarmerlist() {
    return this.http.get(this.url + 'my_farmer_list').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /**  */

  farmerDetails(data) {
    return this.http.get(this.url + 'farmer_details/' + data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /**  */
  saveDependent(data) {
    return this.http.post(this.url + 'dependent', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /**  */
  // updateDependent(data) {
  //   return this.http.put(this.url + 'dependent', data)
  //   .map(response => {
  //     return response;
  //   });
  // }
  updateDependent(data, id) {
    return this.http.put(this.url + 'dependent', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  updateDependentNew(data) {
    return this.http.put(this.url + 'dependent1', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  user_summary() {
    return this.http.get(this.url + 'user_summary').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Save Farm */
  saveFarmer(data) {
    return this.http.post(this.url + 'farmer', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Save Farm */
  saveFarmerMismatch(data) {
    return this.http.post(this.url + 'farmer_mismatch', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Save Farmer Manual */
  saveFarmerMan(data) {
    return this.http.post(this.url + 'farmer_man', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get Manual */
  getFarmerMan() {
    return this.http.get(this.url + 'farmer_man').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Enum Enumerations */
  getMyMan() {
    return this.http.get(this.url + 'enum_enumerations').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  updateFarmer(data) {
    return this.http.put(this.url + 'farmer', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** User */
  resetPassword(data) {
    return this.http.put(this.url + 'reset_password', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** activate  */
  activate(data) {
    return this.http.put(this.url + 'activate', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** deactivate  */

  deactivate(data) {
    return this.http.put(this.url + 'deactivate', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** User */
  getUserHistory(data) {
    return this.http.get(this.url + 'user_history/' + data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get Supervisor History */
  getSupervisorHistory(data) {
    return this.http.get(this.url + 'supervisor_history/' + data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get Total Per Enumerator  */
  getEnumeratorPerformace(data) {
    // router.route('/total_per_enumerator/:id')
    return this.http.get(this.url + 'total_per_enumerator/' + data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Query */



  /** Get Error Log */
  getLogError(data) {
    return this.http.post(this.url + 'error_log', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get Enumerators for a supervisor */
  getSupEnumerator(data) {
    return this.http.get(this.url + 'enum_under_sup/' + data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get Change Log */
  searchChange(data) {
    return this.http.post(this.url + 'edit_farmer_log', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Query Builder */
  assignEnumerator(data) {
    return this.http.post(this.url + 'assign_enumerator', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Query Builder */
  assignEnumerators(data) {
    return this.http.post(this.url + 'assign_enumerators', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Assign Enumerator */
  runQuery(data) {
    return this.http.post(this.url + 'run_query', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Update MongoDB bio  */
  updateFarmerMongo(data) {
    return this.http.post(this.url + 'farmer_bio', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Update MongoDB bio  */
  updateFarmerMongoMismatch(data) {
    return this.http.post(this.url + 'farmer_bio_mismatch', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** User Regional Summary */
  regionalSummary() {
    return this.http.get(this.url + 'regional_summary').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Query Builder */
  queryBuilder() {
    return this.http.get(this.url + 'querybuilder').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Save Community */
  saveCommunity(data) {
    return this.http.post(this.url + 'community', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Edit Community  */

  editCommunity(data) {
    return this.http.put(this.url + 'community', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  getUpdateFarmerCard() {
    return this.http.get(this.url + 'update_farmer_card').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  printApprove(data) {
    return this.http.post(this.url + 'approve_print', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  itdistrictOps() {
    return this.http.get(this.url + 'itdistrict_ops').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  itdistrictUserSummary(data) {
    return this.http.get(this.url + 'district_user_summary/' + data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  loadApprovals() {
    return this.http.get(this.url + 'approvals').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }
  /** Get Work from Enumerator */
  getEnumeratorWork(data) {
    return this.http.get(this.url + 'enumwork/' + data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get Communities in an Operational Area */

  getCommunity(data) {
    return this.http.get(this.url + 'community/' + data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  getCommunityOps(data) {
    return this.http.post(this.url + 'community/1', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Update Farmer Card */
  updateFarmerCard(data) {
    return this.http.put(this.url + 'update_farmer_card', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get District Users */
  getDistrictUsers() {
    return this.http.get(this.url + 'users_district').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** IT audit */
  getITAudit() {
    return this.http.get(this.url + 'it_audit').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** IT Paper Audit */
  getITPaperAudit() {
    return this.http.get(this.url + 'it_audit_paper').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Audit Answer */
  auditAnswer() {
    return this.http.get(this.url + 'audit_answer').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get Supervisors */
  getSupervisors() {
    return this.http.get(this.url + 'supervisors').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get Operational Dashboad for IT District */


  /** activate & deactivate paper user  */

  paperUserActivation(data) {
    return this.http.post(this.url + 'paper_activation', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get district analayis */

  getDistrictAnalysis() {
    return this.http.get(this.url + 'district_analysis').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get District Daily Analysis */
  getDistrictAnalysisDaily() {
    return this.http.get(this.url + 'district_analysis_daily').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get District Daily Analysis */
  getDistrictAnalysisSupervisor() {
    return this.http.get(this.url + 'district_analysis_supervisor').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get District Enumerator Analysis */
  getDistrictAnalysisEnumerator() {
    return this.http.get(this.url + 'district_analysis_enumerator').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get District Enumerator Analysis */
  getEnumeratorAnalysis(data) {
    return this.http.get(this.url + 'enumerator_analysis/' + data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get District Enumerator Analysis */
  editFarmerReadOnly(data) {
    return this.http.put(this.url + 'edit_farmer_readonly', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** reject change */
  rejectCardChange(data) {
    return this.http.put(this.url + 'reject_card_changes', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Check Form */
  async checkFarmerForm(farmerForm) {
    return new Promise((resolve) => {
      /** Other Religion Check */
      let response: any = [];
      // response = {
      //   status: true
      // };

      /** Mobile Checker */
      // console.log(farmerForm.value);
      if (farmerForm.value.telephone) {
        if (
          farmerForm.value.telephone.toString().substr(0, 2) === '02' ||
          farmerForm.value.telephone.toString().substr(0, 2) === '05'
        ) {
        } else {
          response.push({
            status: false,
            message: `MOBILE NUMBER format is wrong`,
          });
        }
      }

      /** Title Checker */

      if (farmerForm.value.title === 'OTHER') {
        // console.log(farmerForm.value.title_other.length);
        if (farmerForm.value.title_other.length < 2) {
          response.push({
            status: false,
            message: `TITLE is empty or incorrect`,
          });
        }
      }

      if (farmerForm.value.religion === 'OTHERS') {
        if (farmerForm.value.religion_others.length < 2) {
          response.push({
            status: false,
            message: `OTHER RELIGION is empty or incorrect`,
          });
        }
      }

      /** Farmer Group Check */
      if (farmerForm.value.groupmembership === 'YES') {
        if (farmerForm.value.farmergroup.length < 2) {
          response.push({
            status: false,
            message: `NAME OF FARMER GROUP is required`,
          });
        }
      }

      /** Farmer Co operative Membership */
      if (farmerForm.value.cooperativemembership === 'YES') {
        if (farmerForm.value.cooperative.length < 2) {
          response.push({
            status: false,
            message: `NAME OF COOPERATIVE is required`,
          });
        }
      }

      /** Farmer Main Source */
      if (farmerForm.value.mainsource === 'NO') {
        if (farmerForm.value.otherincome.length < 2) {
          response.push({
            status: false,
            message: `OTHER SOURCE OF INCOME is required`,
          });
        }
      }
      /** Farmer Speciality Cocoa*/
      if (farmerForm.value.specialitycocoa === 'YES') {
        // console.log(farmerForm.value.typeofspeciality);
        if (farmerForm.value.certification.length < 2) {
          response.push({
            status: false,
            message: `TYPE OF CERTIFICATION is required`,
          });
        }
      }
      // /** Farmer Speciality Cocoa*/
      // if (farmerForm.value.typeofspeciality === 'CERTIFIED') {
      //   if (farmerForm.value.certification) {
      //       response = {
      //         status: true
      //       };
      //       } else {
      //         response =  {
      //           status: false,
      //           message: `TYPE OF CERIFICATION is required`
      //         };
      //       }
      //   }
      /** Certification Others Check*/
      if (
        farmerForm.value.certification === 'OTHERS' &&
        farmerForm.value.specialitycocoa === 'YES'
      ) {
        if (farmerForm.value.certification_others.length < 2) {
          response.push({
            status: false,
            message: `TYPE OF CERTIFICATION is required`,
          });
        }
      }
      resolve(response);
    });
  }

  /** Coordinator */

  /** Get Operational Dashboad for IT District */
  getCoordinatorTaget(region_code, regional_name) {
    return this.http
      .get(this.url + 'coordinator_target/' + region_code + '/' + regional_name)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(this.handleError)
      );
  }

  /** Get Operational Dashboad for IT District */
  getCoordinatorOps(data) {
    return this.http.post(this.url + 'coordinator_ops', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Print List */
  printOps(data) {
    return this.http.get(this.url + 'printlist/' + data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get Enum List  */
  printEnum(data) {
    return this.http.get(this.url + 'print_enum_list/' + data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get Unapproved List */

  getUnapprovedPrint() {
    return this.http.get(this.url + 'unapproved_print').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get Card Details */
  getCardDetails(data) {
    return this.http.get(this.url + 'card_details/' + data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** card changes approval */

  approveCardChange(data) {
    return this.http.post(this.url + 'card_changes', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /**  */
  getOpsReport(region) {
    return this.http.get(this.url + 'operational_count/' + region).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get Supervisor of an enumerators */
  getEnumSupervisor(user) {
    return this.http.get(this.url + 'enum_supervisor/' + user).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Remove Enumerators */
  removeEnumerator(user) {
    return this.http.post(this.url + 'remove_enumerator', user).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /**  */
  loadSerial() {
    return this.http.get(this.url + 'serial').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  saveSerial(data) {
    return this.http.post(this.url + 'serial', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /**  */

  /** Digital Admin */
  loadFarmers(data) {
    return this.http.post(this.url + 'card_first', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** */
  // card_second
  loadFarmersSecond(data) {
    return this.http.post(this.url + 'card_second', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /**  */
  getAuditDistrict(data) {
    return this.http.post(this.url + 'district_audit', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get manual district */
  getManualDistrict(data) {
    return this.http.post(this.url + 'district_manual', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }



  /**  */
  saveAuditDistrict(data) {
    return this.http.post(this.url + 'district_audit_answer', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  saveIssue(data) {
    return this.http.post(this.url + 'issues', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  getIssue() {
    return this.http.get(this.url + 'issues').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** End of Digital Admin */


  /** LBC */
  saveLBC(data: Object) {
    return this.http.post(this.url + 'lbc', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  getLBC() {
    return this.http.get(this.url + 'lbc').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }


   /** LBC */
   savePC(data: Object) {
    return this.http.post(this.url + 'pc', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  getPC() {
    return this.http.get(this.url + 'pc').pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  /** Get Farmers in an Operational Area */
  getFarmerInOps(data) {
    return this.http.post(this.url + 'farmer_in_ops', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }


   /** Get Farmers in an District */
   getFarmerInDistrict(data) {
    return this.http.post(this.url + 'farmer_in_district', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }


   /** Get Farmers in an District */
   updateMopupFarmer(data: Object) {
    return this.http.post(this.url + 'mopup_farmer', data).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }



  /** End of Coordinator */

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    // this.auth.logout();
    // this.toastr.error('A critical Error Occured, Please contact the administrator');
    return throwError('Something bad happened; please try again later.');
  }
}
